"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { homePathFor, useAuth } from "@/lib/auth";
import { ButtonLink } from "@/components/ui/Button";
import { Logo } from "@/components/ui/Logo";

const FEATURES = [
  {
    title: "참여 가능 여부 판정",
    body: "면허제한 AND·OR 조건, 직접생산 세부품명, 지역제한, 실적 요건, 보안 조항을 업체 조건과 대조합니다.",
  },
  {
    title: "재공고 분석",
    body: "원공고의 유찰 사유와 직전 공고 대비 바뀐 조건을 정리합니다.",
  },
  {
    title: "공고 맞춤 AI 상담",
    body: "공고 한 건을 두고 자격, 배점, 제출서류를 묻고 답을 받습니다.",
  },
];

export default function Home() {
  const { status, me } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (status === "authenticated") router.replace(homePathFor(me));
  }, [status, me, router]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="mx-auto flex h-16 w-full max-w-[1120px] items-center px-5 sm:px-8">
        <Logo />
        <div className="ml-auto flex items-center gap-2">
          <ButtonLink href="/login" variant="ghost">
            로그인
          </ButtonLink>
          <ButtonLink href="/signup">무료로 시작하기</ButtonLink>
        </div>
      </header>

      <main className="flex-1">
        <section className="mx-auto max-w-[1120px] px-5 pb-20 pt-16 sm:px-8 sm:pt-24">
          <p className="text-sm font-semibold text-primary-900">나라장터 용역 공고 판독</p>
          <h1 className="mt-4 max-w-[720px] text-2xl font-bold text-gray-900 sm:text-[44px] sm:leading-[58px]">
            우리 회사가 이 공고에 참여할 수 있는지, 공고문을 열기 전에 확인하세요
          </h1>
          <p className="mt-6 max-w-[600px] text-lg text-gray-600">
            사업자등록번호 하나로 나라장터 등록 정보를 불러오고, 공고의 참가자격과 배점을 업체 조건과 대조해 판정합니다.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <ButtonLink href="/signup" size="lg">
              무료로 시작하기
            </ButtonLink>
            <ButtonLink href="/login" size="lg" variant="outline">
              로그인
            </ButtonLink>
          </div>
        </section>

        <section className="bg-gray-200">
          <div className="mx-auto grid max-w-[1120px] gap-4 px-5 py-16 sm:grid-cols-3 sm:px-8">
            {FEATURES.map((f) => (
              <div key={f.title} className="rounded-lg bg-white p-6 shadow-card">
                <h2 className="text-lg font-bold text-gray-900">{f.title}</h2>
                <p className="mt-2 text-sm text-gray-600">{f.body}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className="border-t border-gray-400 bg-white">
        <div className="mx-auto flex max-w-[1120px] flex-wrap items-center gap-x-6 gap-y-2 px-5 py-8 text-xs text-gray-600 sm:px-8">
          <span>케이플(KAYPLE) · 사업자등록번호 422-02-00640 · 서울특별시 마포구 양화로 85, 9층</span>
          <a href="/terms" className="hover:text-gray-900">
            이용약관
          </a>
          <a href="/privacy" className="hover:text-gray-900">
            개인정보처리방침
          </a>
        </div>
      </footer>
    </div>
  );
}
